import React, { useEffect, useState } from "react";
import { Modal, Form, Input, message, Button, Select } from "antd";

import { useAsync } from "../../../../../utils/use-async";
import { useAuth } from "../../../../../context/auth-context";
import { client } from "../../../../../utils/api-client";
import { Spinner } from "../../../../lib";

const { Option } = Select;

const AddTargetForOneUser = ({
  modal,
  setModal,
  projectId,
  targetId,
  prevData,
}) => {
  const { isLoading, run, isError, error } = useAsync();
  const { user } = useAuth();
  const [userForm] = Form.useForm();
  const [users, setUsers] = useState([]);
  useEffect(() => {
    run(client(`/one/user/target/${targetId}`)).then((res) => {
      setUsers(res.data.filteredUsers);
    });
  }, [run]);

  const addSection = (values) => {
    run(
      client(`/add/one/user/target`, {
        body: { ...values, targetId: targetId },
      }).then((res) => {
        message.success(res.message);
        setModal(false);
        userForm.resetFields();
        prevData();
      })
    );
  };

  const handleCancel = () => {
    setModal(false);
    userForm.resetFields();
  };

  return (
    <Modal
      title="Assign Target"
      open={modal}
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        form={userForm}
        size="middle"
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
        onFinish={addSection}
      >
        <Form.Item
          label="User Name"
          name="userId"
          rules={[{ required: true, message: "Please select a user!" }]}
        >
          <Select placeholder="Select a user">
            {users?.map((u) => (
              <Option key={u._id} value={u.email}>
                {u.email}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Assigned Task"
          name="target_assigned"
          rules={[{ required: true, message: "Please enter task count!" }]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item
          label="Effective Date"
          name="dateEffective"
          rules={[
            { required: true, message: "Please enter an effective date!" },
          ]}
        >
          <Input type="date" />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" disabled={isLoading}>
            Submit{" "}
            {isLoading && (
              <Spinner style={{ marginLeft: 5, verticalAlign: "middle" }} />
            )}
          </Button>
        </Form.Item>

        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default AddTargetForOneUser;
